<template>
  <ul class="list-group list-group-flush list">
    <li v-for="(item, index) in list" :key="typeof(itemKey) == 'function' ? itemKey(item) : item[itemKey]" class="list-group-item px-0" style="padding: 0">
      <base-button 
        :outline="!isSelected(item)" :type="isSelected(item) ? 'success' : 'secondary'"
        @click="selectItem(item, $event)"
        :style="'width: 100%;border:none;z-index:' + (list.length + 10 - index)"
      >
        <div class="row align-items-center">
          <slot name="title" :item="item" :isSelected="isSelected(item)">
            <div class="col ml--2">
              <h4 class="mb-0 text-left" :class="{'text-white': isSelected(item)}">{{ item[itemName] }}</h4>
            </div>
          </slot>
          <div v-if="actions">
            <base-dropdown icon="fas fa-ellipsis-v" :hasToggle="false" titleTag="a">
              <slot name="actions" :item="item"></slot>
            </base-dropdown>
          </div>
        </div>
      </base-button>
    </li>
  </ul>
</template>

<script>
export default {
  name: "dynamic-list",
  props: {
    list: {
      type: Array,
      default: () => [],
      description: "List of objects to be listed."
    },
    itemName: {
      type: String,
      required: true,
    },
    itemKey: {
      type: [String, Function],
      default: item => JSON.stringify(item),
    },
    actions: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      selectedItem: {},
    }
  },
  methods: {
    selectItem(item, event) {
      event.preventDefault()
      event.stopPropagation()
      this.selectedItem = item
      this.$emit('item-selected', this.selectedItem)
    },
    isSelected(item){
      const itemKey = typeof(this.itemKey) == 'function' ? this.itemKey(item) : item[this.itemKey]
      const selectedItemKey = typeof(this.itemKey) == 'function' ? this.itemKey(this.selectedItem) : this.selectedItem[this.itemKey]
      return selectedItemKey == itemKey
    },
  }
};
</script>
